<template>
  <div class="pl-4">
    <div class="text-white pt-3">
      <a @click="routeToGrooveSupport" class="cursor-pointer">{{
        capitalizeFirstLetter($t('frontend_gd_dashboard_groove_support'))
      }}</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    capitalizeFirstLetter(str) {
      return str
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    routeToGrooveSupport() {
      window.open(this.$t('official_link_support'), '_blank');
    },
  },
};
</script>
